// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bXEW","question":"styles_question__3IbMb","description":"styles_description__10sDT"};